import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import acknowledgmentReadModal from 'store/app/ui/modals/acknowledgment/read/action';
import documentModal from 'store/app/ui/modals/document/action';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  actions: {
    documentModal: bindActionCreators(documentModal, dispatch),
    acknowledgmentReadModal: bindActionCreators(acknowledgmentReadModal, dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
